<template>
    <div class="login">
      <div class="login_div">
          <el-form className="login-container" label-position="left" label-width="0px" :rules="rule" :model="loginForm">
              <h2 className="login_title">系统登录</h2>
              <el-form-item prop="username" style="margin-top: 50px">
                  <el-input type="text" v-model="loginForm.username" auto-complete="off" placeholder="账号"></el-input>
              </el-form-item>

              <el-form-item prop="password" style="margin-top: 30px">
                  <el-input type="password" v-model="loginForm.password" auto-complete="off" placeholder="密码"></el-input>
              </el-form-item>

              <el-form-item style="width: 100%;margin-top: 50px">
                  <el-button type="primary" style="width: 100%;background: #505458;border: none" class="login-btn"
                             @click="login('loginForm')">登录
                  </el-button>
              </el-form-item>
          </el-form>
      </div>
    </div>
</template>


<script>
    import {login} from '../../api/admin/admin';
    import { ElMessage } from 'element-plus';

    export default {
        name: "Login",
        data() {
            return {
                loading:true,
                loginForm: {
                    // username: 'snkshe',
                    // password: 'Jaysnkshe1'
                    username: '',
                    password: ''
                },
                rule: {
                    username: [
                        {required: true, message: '用户名不能为空！', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '密码不能为空！', trigger: 'blur'}
                    ],
                },
            }
        },
        mounted() {
            const token = localStorage.getItem('token');
            console.log("检测登录：" + token);
            if (token) {
                this.$router.replace("/pages/index/index");
            }
        },
        methods: {
            //新增
            login(formName) {
                this.loading = true;
                login(this.loginForm).then(res => {
                    const code = res.data.code;
                    const msg = res.data.msg;
                    console.log(res.data);
                    if (code === "200") {
                        const token=res.data.data;
                        window.sessionStorage.setItem("token", token);
                        localStorage.setItem('token', token);
                        window.sessionStorage.setItem("userInfo", JSON.stringify(res.data.data));
                        this.$router.replace("/pages/index/index");
                        this.loading = false;
                        ElMessage({
                            message: '登录成功',
                            type: 'success',
                        });
                    } else {
                        ElMessage.error(msg);
                    }
                });
            }
        }
    }
</script>

<style lang="less" scoped>
    .login {
        background: url("../../assets/img/loginBC2.png") no-repeat;
        background-position: center;
        height: 100%;
        width: 100%;
        background-size: cover;
        position: fixed;

        .login_div {
            /*margin-top: auto;*/
            margin-top: 10%;
        }

        h2 {
            font-weight: bolder;
            font-size: 20px;
            letter-spacing: 5px;
            /*color: deepskyblue;*/
            text-align: center;

        }
    }

    body {
        margin: 0;
        padding: 0;
    }

    .login-container {
        border-radius: 15px;
        background-clip: padding-box;
        margin: 90px auto;
        width: 350px;
        height: 350px;
        padding: 35px 35px 15px 35px;
        background: #fff;
        border: 1px solid #eaeaea;
        box-shadow: 0 0 25px #cac6c6;
    }

    .login_title {
        margin: 0 auto 40px auto;
        text-align: center;
        color: #505458;
    }

    .login-btn:hover{
        background: lightskyblue;
    }


</style>
